<template>
    <div>
        <v-container>
            <v-row>
                <v-col cols="8">
                    <!-- <div v-html="formattedContent(form.kebijakanVendor.content)" class="wrap-content"></div> -->
                    <v-textarea
                          label=""
                          readonly
                          v-model="form.kebijakanVendor.content"
                          rows="70"
                          persistent-hint
                          style="border: none;"
                        ></v-textarea>
                </v-col>
                <v-col cols="4">
                    <h3>Lampiran</h3>
                    <v-list>
                        <v-list-item
                            v-if="form.kebijakanVendor.file1"
                            @click="getLinkDownload(form.kebijakanVendor.file1)"
                        >
                            <v-list-item-title>{{ form.kebijakanVendor.file1 }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="form.kebijakanVendor.file2"
                            @click="getLinkDownload(form.kebijakanVendor.file2)"
                        >
                            <v-list-item-title>{{ form.kebijakanVendor.file2 }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="form.kebijakanVendor.file3"
                            @click="getLinkDownload(form.kebijakanVendor.file3)"
                        >
                            <v-list-item-title>{{ form.kebijakanVendor.file3 }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
  const axios = require("axios").default;
  const apiUrl = process.env.VUE_APP_ROOT_API;
  export default {
    data() {
      return {
        valid: true,
        form : {
          kebijakanVendor: 
          {
            id: 1,
            content: "",
            file1: '',
            file2: '',
            file3: '',
            createdAt: null,
            updatedAt: null,
          }
        },
        notification: {
            show: false,
            color: "success",
            text: ""
        },

        submitting: false,
        loginExpired: false
      };
    },
    created() {
      this.getData();
    },
    methods: {
        formattedContent(content) {
            return content.replace(/\n/g, "<br>").replace(/ /g, "&nbsp;");
        },
        getData() {
            axios
                .get(`${apiUrl}/api/kebijakan-vendor/${this.form.kebijakanVendor.id}`)
                .then((response) => {
                    this.form.kebijakanVendor = { ...response.data };
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        getLinkDownload(dok) {
            axios
                .get(`${apiUrl}/${dok}`, { responseType: "blob" })
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: response.headers["content-type"],
                    });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = dok.split('/').pop(); // Extract filename from path
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch(console.error);
        },
    },

  };
  </script>
<style>
.wrap-content {
  word-wrap: break-word;
  white-space: normal;   
  overflow: auto;        
  max-height: 100%;   
}
</style>